// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","discountBadge":"G76a260","discountCopy":"Gedbbc6"};